import { htmlNew, htmlTagged, htmlOnInput } from '../fun-js-lib/html'
import { maxNLinesInRemarks } from '../pdfPrinter/draw-page/lower/remarks'
import { emptyCanvas } from '../pdfPrinter/draw-page/otherPageImg'
import { nLinesInRemarks } from '../pdfPrinter/draw-page/texts'
import { tooLongRemarksHint } from './hint'

export function initValidateRemarks () {
  let input = remarksInputElement()
  htmlOnInput(input, validate)

  validate()
}

export const isRemarksFilledIncorrectly = () =>
  !isValid()

export function isRemarksInputElementEmpty () {
  return nLinesInInputElement() === 0
}

function validate () {
  let valid = isValid()
  container().classList.toggle('is-invalid', !valid)
  if (valid) {
    unsetErrorHint()
  } else {
    setErrorHint()
  }
}

function isValid () {
  const maxJsonLength = 20000
  const nLines = nLinesInInputElement()
  const length = jsonOfInputElement().length
  return nLines <= maxNLinesInRemarks && length <= maxJsonLength
}

/**
 * Returns json value of remarks input element
 */
function jsonOfInputElement () {
  return remarksInputElement().value
}

function nLinesInInputElement () {
  let emptyContext = emptyCanvas.getContext('2d')
  return nLinesInRemarks(emptyContext, jsonOfInputElement())
}

function setErrorHint () {
  unsetErrorHint()
  let h6 = htmlNew('h6')
  h6.classList.add('text-center')
  let small = htmlNew('small')
  small.classList.add('text-danger')
  small.classList.add('h6')
  small.innerHTML = tooLongRemarksHint
  h6.appendChild(small)
  container().prepend(h6)
}

function unsetErrorHint () {
  htmlTagged(container(), 'h6')
    .forEach(h6 => h6.remove())
}

export function remarksInputElement () {
  return htmlTagged(container(), 'input')
    .filter(input => input.classList.contains('quill-hidden-input'))[0]
}

function container () {
  return document.getElementById('remarksContainer')
}